import React, { useContext, useState } from 'react';
import { withStyles, List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUserCircle, faTags, faChartSimple, faUserShield,faMoneyCheckDollar } from '@fortawesome/free-solid-svg-icons';
import ProductSubmenu from './ProductSubmenu';
import LegalSubmenu from './LegalSubmenu';
import { NavLink } from 'react-router-dom';
import { UserAccountContext } from '../../../contextHooks';

const styles = () => ({
    ListItemCss: { display: 'block', textAlign: 'center', paddingTop: 10, paddingBottom: 3 },
    ListContainer: { textAlign: 'center' },
    ListItemIconCss: { minWidth: 0, fontSize: 30, color: '#fff' },
    ListItemTextCss: { color: '#fff', fontSize: 11 },
    ListItemCssActive: { display: 'block', textAlign: 'center', paddingTop: 10, paddingBottom: 3, background: '#fff', borderLeft: '3px solid #1b5e20', '&:hover': { background: '#fff' } },
    ListItemCssClicked: { display: 'block', textAlign: 'center', paddingTop: 10, paddingBottom: 3, background: '#f5f1f1', borderLeft: '3px solid #1b5e20', '&:hover': { background: '#f5f1f1' } },
    ListItemIconCssActive: { color: '#1b5e20', minWidth: 0, fontSize: 30 },
    ListItemTextCssActive: { color: '#1b5e20', fontSize: 11 },
})
const SideNavigationsMenu = (props) => {
    const { classes, pageUri } = props;
    const userAccount = useContext(UserAccountContext);
    const productsItems = ['create', 'list-all', 'edit'];
    const activityItems = ['list-all', 'product', 'idle'];
    const legalItems = ['create', 'list-all', 'edit', 'legal-center', 'legal-details'];
    const profileItems = ['profile'];
    const adminItems = ['manage-users', 'edit-user'];
    const billingItems = ['billing'];

    const [subNavSelected, setSubNavSelected] = useState(null);
    const [clickedItem, setClickedItem] = useState(null);

    const openSubNavigation = (subNavItem) => {
        setSubNavSelected(subNavItem);
        setClickedItem(subNavItem);
    }
    const closesSubNavgation = () => {
        setSubNavSelected(null);
        setClickedItem(null);
    }

    let pageSplit = pageUri.split('/');
    let rootPage = pageSplit[1];
    let productIndex = productsItems.indexOf(pageSplit[2]);
    let activityIndex = activityItems.indexOf(pageSplit[2]);
    let legalIndex = legalItems.indexOf(pageSplit[2]);
    let profileIndex = profileItems.indexOf(pageSplit[2]);
    let adminIndex = adminItems.indexOf(pageSplit[2]);
    let billingIndex = billingItems.indexOf(pageSplit[2]);

    const SideBarListItems = (
        <div className={classes.ListContainer}>
            <List component='div' disablePadding>
                <ListItem
                    button
                    disableGutters
                    component={NavLink}
                    to="/activities/list-all"
                    className={
                        (clickedItem === 'activities') ? classes.ListItemCssClicked :
                            (rootPage === 'activities' && activityIndex >= 0)
                                ? classes.ListItemCssActive
                                : classes.ListItemCss
                    }
                >
                    <ListItemIcon
                        className={
                            ((rootPage === 'activities' && activityIndex >= 0) || (clickedItem === 'activities'))
                                ? classes.ListItemIconCssActive
                                : classes.ListItemIconCss
                        }
                    >
                        <FontAwesomeIcon icon={faChartSimple} />
                    </ListItemIcon>
                    <ListItemText
                        primary='Activities'
                        classes={
                            ((rootPage === 'activities' && activityIndex >= 0) || (clickedItem === 'activities'))
                                ? { primary: classes.ListItemTextCssActive }
                                : { primary: classes.ListItemTextCss }
                        }
                    />
                </ListItem>
                <ListItem
                    button
                    disableGutters
                    className={
                        (clickedItem === 'products') ? classes.ListItemCssClicked :
                            (rootPage === 'products' && productIndex >= 0)
                                ? classes.ListItemCssActive
                                : classes.ListItemCss
                    }
                    onClick={() => { openSubNavigation('products') }}
                >
                    <ListItemIcon
                        className={
                            ((rootPage === 'products' && productIndex >= 0) || (clickedItem === 'products'))
                                ? classes.ListItemIconCssActive
                                : classes.ListItemIconCss
                        }
                    >
                        <FontAwesomeIcon icon={faTags} />
                    </ListItemIcon>
                    <ListItemText
                        primary='Products'
                        classes={
                            ((rootPage === 'products' && productIndex >= 0) || (clickedItem === 'products'))
                                ? { primary: classes.ListItemTextCssActive }
                                : { primary: classes.ListItemTextCss }
                        }
                    />
                </ListItem>
                <ProductSubmenu
                    openState={(subNavSelected === 'products') ? true : false}
                    closeSubNavigation={() => { closesSubNavgation() }}
                />

                <ListItem
                    button
                    disableGutters
                    className={
                        (clickedItem === 'legals') ? classes.ListItemCssClicked :
                            (rootPage === 'legals' && legalIndex >= 0)
                                ? classes.ListItemCssActive
                                : classes.ListItemCss
                    }
                    onClick={() => { openSubNavigation('legals') }}
                >
                    <ListItemIcon
                        className={
                            ((rootPage === 'legals' && legalIndex >= 0) || (clickedItem === 'legals'))
                                ? classes.ListItemIconCssActive
                                : classes.ListItemIconCss
                        }
                    >
                        <FontAwesomeIcon icon={faTags} />
                    </ListItemIcon>
                    <ListItemText
                        primary='Legals'
                        classes={
                            ((rootPage === 'legals' && legalIndex >= 0) || (clickedItem === 'legals'))
                                ? { primary: classes.ListItemTextCssActive }
                                : { primary: classes.ListItemTextCss }
                        }
                    />
                </ListItem>
                <LegalSubmenu
                    openState={(subNavSelected === 'legals') ? true : false}
                    closeSubNavigation={() => { closesSubNavgation() }}
                />
                {/* <ListItem button disableGutters classes={{ button: classes.ListItemCss }}>
                    <ListItemIcon classes={{ root: classes.ListItemIconCss }}>
                        <FontAwesomeIcon icon={faUserCircle} />
                    </ListItemIcon>
                    <ListItemText classes={{ primary: classes.ListItemTextCss }} primary='Profile' />
                </ListItem> */}

                <ListItem
                    button
                    disableGutters
                    component={NavLink}
                    to="/auth/profile"
                    className={
                        (clickedItem === 'auth') ? classes.ListItemCssClicked :
                            (rootPage === 'auth' && profileIndex >= 0)
                                ? classes.ListItemCssActive
                                : classes.ListItemCss
                    }
                >
                    <ListItemIcon
                        className={
                            ((rootPage === 'auth' && profileIndex >= 0) || (clickedItem === 'auth'))
                                ? classes.ListItemIconCssActive
                                : classes.ListItemIconCss
                        }
                    >
                        <FontAwesomeIcon icon={faUserCircle} />
                    </ListItemIcon>
                    <ListItemText
                        primary='Profile'
                        classes={
                            ((rootPage === 'auth' && profileIndex >= 0) || (clickedItem === 'auth'))
                                ? { primary: classes.ListItemTextCssActive }
                                : { primary: classes.ListItemTextCss }
                        }
                    />
                </ListItem>

                <ListItem
                    button
                    disableGutters
                    component={NavLink}
                    to="/auth/billing"
                    className={
                        (clickedItem === 'auth') ? classes.ListItemCssClicked :
                            (rootPage === 'auth' && billingIndex >= 0)
                                ? classes.ListItemCssActive
                                : classes.ListItemCss
                    }
                >
                    <ListItemIcon
                        className={
                            ((rootPage === 'auth' && billingIndex >= 0) || (clickedItem === 'auth'))
                                ? classes.ListItemIconCssActive
                                : classes.ListItemIconCss
                        }
                    >
                        <FontAwesomeIcon icon={faMoneyCheckDollar} />
                    </ListItemIcon>
                    <ListItemText
                        primary='Billing'
                        classes={
                            ((rootPage === 'auth' && billingIndex >= 0) || (clickedItem === 'auth'))
                                ? { primary: classes.ListItemTextCssActive }
                                : { primary: classes.ListItemTextCss }
                        }
                    />
                </ListItem>

                {
                    (userAccount && (userAccount.usr_role_id === '2')) &&
                    <ListItem
                        button
                        disableGutters
                        component={NavLink}
                        to="/admin/manage-users"
                        className={
                            (clickedItem === 'admin') ? classes.ListItemCssClicked :
                                (rootPage === 'admin' && adminIndex >= 0)
                                    ? classes.ListItemCssActive
                                    : classes.ListItemCss
                        }
                    >
                        <ListItemIcon
                            className={
                                ((rootPage === 'admin' && adminIndex >= 0) || (clickedItem === 'admin'))
                                    ? classes.ListItemIconCssActive
                                    : classes.ListItemIconCss
                            }
                        >
                            <FontAwesomeIcon icon={faUserShield} />
                        </ListItemIcon>
                        <ListItemText
                            primary='Admin'
                            classes={
                                ((rootPage === 'admin' && adminIndex >= 0) || (clickedItem === 'admin'))
                                    ? { primary: classes.ListItemTextCssActive }
                                    : { primary: classes.ListItemTextCss }
                            }
                        />
                    </ListItem>
                }

            </List>
        </div>
    )
    return (
        <React.Fragment>
            <div>
                {SideBarListItems}
            </div>
        </React.Fragment>
    )
}

export default withStyles(styles)(SideNavigationsMenu)